export default __webpack_public_path__ + "static/media/aqi-index.552870d0.jpg";